import axios from 'axios';
import {ConfigService} from '@nuskin/ns-util';

const STRIPE_PAYMENT_URL = "/stripePayments/v2/charge";
const CREATE_PAYMENT_INTENT_URL = "/stripePayments/v2/paymentIntent";
const GET_PAYMENT_INTENT_URL = "/stripePayments/v2/paymentIntentStatus";

export default {
    postPaymentTokenToStripe,
    createPaymentIntent,
    getPaymentIntent
}

/**
 * Posts payment token and user data to Stripe Payment AWS Service
 * @param _amount
 * @param _token
 * @param _email
 * @param _firstname
 * @param _lastname
 * @param _affiliateId
 * @returns {Promise<AxiosResponse<any>>|*}
 */
function postPaymentTokenToStripe(_dollarAmount, _token, _email, _firstname, _lastname, _affiliateId, _captcha) {

    let postBody = {
        amount: Math.round(Number(_dollarAmount) * 100), //Stripe expects the cent amount to be sent
        paymentToken: _token,
        email: _email,
        firstName: _firstname,
        lastName: _lastname,
        affiliateId: _affiliateId,
        captcha: _captcha
    };

    //Required fields
    if (!_dollarAmount || !_token || !_firstname || !_lastname) {
        return Promise.reject();
    }

    let marketConfig = ConfigService.getMarketConfig();
    return axios.post(marketConfig.awsUrl + STRIPE_PAYMENT_URL, postBody);
}

/**
 * Posts a payment intent and user data to Stripe Payment AWS Service
 * @param _amount
 * @param _email
 * @param _firstname
 * @param _lastname
 * @param _affiliateId
 * @returns {Promise<AxiosResponse<any>>|*}
 */
function createPaymentIntent(_dollarAmount, _email, _firstname, _lastname, _affiliateId, _captcha) {

    let postBody = {
        amount: Math.round(Number(_dollarAmount) * 100), //Stripe expects the cent amount to be sent
        email: _email,
        firstName: _firstname,
        lastName: _lastname,
        affiliateId: _affiliateId,
        captcha: _captcha
    };

    //Required fields
    if (!_dollarAmount || !_firstname || !_lastname) {
        return Promise.reject();
    }

    let marketConfig = ConfigService.getMarketConfig();
    return axios.post(marketConfig.awsUrl + CREATE_PAYMENT_INTENT_URL, postBody);
}

/**
 * Gets a Stripe Payment Intent object from Stripe Payment AWS Service
 * @param _paymentIntentId
 * @returns {Promise<AxiosResponse<any>>|*}
 */
function getPaymentIntent(_paymentIntentId) {

    //Required fields
    if (!_paymentIntentId) {
        return Promise.reject();
    }

    let marketConfig = ConfigService.getMarketConfig();

    return axios.get(marketConfig.awsUrl + GET_PAYMENT_INTENT_URL + `/${_paymentIntentId}`);
}
